export default "__VITE_PUBLIC_ASSET__50c285b5__"